import { API } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DualRing } from "react-loading-io";
import NumberFormat from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import img from "../Resources/img/image-user.jpg";
import {
  getAdditionalInfo1,
  getAdditionalInfo2,
  getQuizDPS,
} from "../Store/quiz/actions";
import { updateClient } from "../Store/simulate/actions";
import {
  validateEmail,
  validateHomePhone,
  validatePhone,
  validatorClientText,
  validatorDate,
  validatorField,
} from "../Utils/validators";
import useBeforeFirstRender from "../customHook/useBeforFirstRender";
import ListAddresses from "../Components/FormElements/listAddresses";
import Step from "../Components/FormElements/step";
import ErrorCustom from "../Components/errorCustom";
import ModalAddress from "../Components/modalAddress";
import RadioButtonsResident from "../Components/radioButtonsResident";
import RadioButtonsSexo from "../Components/radioButtonsSexo";
import TitleHeader from "./titleHeader";

export default function ClientData() {
  const data = useSelector((state) => state.simulate.policy.client);
  const client = data.datosCliente;
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [activeInput, setActiveInput] = useState(false);

  const { handleSubmit, register, setValue, errors } = useForm();
  const [id, setId] = useState(null);
  const [docType, setDocType] = useState("");
  const [document, setDocument] = useState("");
  const [names, setNames] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [sexo, setSexo] = useState(null);
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);
  const [address, setAddress] = useState({});
  const [errAddress, setErrAddress] = useState("");

  useEffect(() => {
    getQuizDPS(dispatch);
    getAdditionalInfo1(dispatch);
    getAdditionalInfo2(dispatch);
    if (client && client.documento && client.tipoDoc) {
      getDataClient(client.documento, client.tipoDoc.valor);
    }
  }, []);

  const getDataClient = async (document, docType) => {
    setLoading(true);

    const params = {
      numDocumento: document,
      tipoDocumento: docType,
      idSimulacion: data.idSimulacion,
    };

    try {
      const response = await API.post("api-rentas", "/client", {
        body: params,
        headers: {},
      });
      setDocType(`${docType}`);
      setDocument(document);

      if (response.status === 200) {
        setActiveInput(true);
        setId(response.data.idetercero);
        setNames(response.data.nombres);
        setFirstName(response.data.apellidoPaterno);
        setLastName(response.data.apellidoMaterno);
        setBirthdate(response.data.fecNacimiento);
        setSexo(response.data.sexo);
        setMobile(response.data.celular);
        setEmail(response.data.correo);
      } else {
        setNames(client.nombre);
        setFirstName(client.apePaterno);
        setLastName(client.apeMaterno);
        setBirthdate(client.nacimiento);
        setMobile(client.celular);
        setEmail(client.correo);
      }
    } catch (error) {
      setLoading(false);
      history.push("/simulaciones");
    }
  };

  const navigationPrev = () => {
    history.push("/simulaciones");
  };

  const onSubmit = (values) => {
    if (Object.keys(address).length === 0) {
      setErrAddress("Ingrese una dirección");
      return false;
    } else {
      setErrAddress("");
    }
    const data = {
      idetercero: id,
      datosParticulares: {
        ...values,
        address,
      },
    };
    dispatch(updateClient(data));
    history.push("/simulaciones/datos-laborales");
    // history.push('/simulaciones/verificacion');
  };

  useBeforeFirstRender(client);

  return (
    <div className="container">
      <div className="clientData">
        <div className="column">
          <Step handleClick={() => navigationPrev()} step="1" total="7" />
          <TitleHeader
            title="Datos del"
            titleBold="cliente"
            subtitle="Para poder asegurarlo necesitamos la siguiente información"
          />
          <div className="column__form">
            {loading && (
              <div className="loading-field">
                <DualRing size={50} />
              </div>
            )}
            <form className="clientForm" onSubmit={handleSubmit(onSubmit)}>
              <div className="clientForm__control">
                <div className="clientForm__control__inputSelect">
                  <select
                    value={docType}
                    className="browser-default"
                    name="typeDoc"
                    ref={register}
                    disabled="disabled"
                  >
                    <option value="2">DNI</option>
                    <option value="1">CE</option>
                  </select>
                  <div className="input-field">
                    <input
                      id="document"
                      name="document"
                      ref={register}
                      defaultValue={document}
                      readOnly
                      maxLength="15"
                      type="text"
                    />
                    <label className="active" htmlFor="document">
                      Nro. documento
                    </label>
                  </div>
                </div>
              </div>

              <div className="clientForm__control input-field">
                <input
                  id="names"
                  name="names"
                  ref={register({ validate: validatorField })}
                  defaultValue={names}
                  readOnly={activeInput}
                  maxLength="30"
                  type="text"
                />
                <label className={names ? "active" : ""} htmlFor="names">
                  Nombres
                </label>
                <ErrorCustom errors={errors} name="names" />
              </div>

              <div className="clientForm__control input-field">
                <input
                  id="firstName"
                  name="firstName"
                  ref={register({ validate: validatorField })}
                  defaultValue={firstName}
                  readOnly={activeInput}
                  maxLength="30"
                  type="text"
                />
                <label
                  className={firstName ? "active" : ""}
                  htmlFor="firstName"
                >
                  Apellido paterno
                </label>
                <ErrorCustom errors={errors} name="firstName" />
              </div>

              <div className="clientForm__control input-field">
                <input
                  id="lastName"
                  name="lastName"
                  ref={register({ validate: validatorField })}
                  defaultValue={lastName}
                  readOnly={activeInput}
                  maxLength="30"
                  type="text"
                />
                <label className={lastName ? "active" : ""} htmlFor="lastName">
                  Apellido materno
                </label>
                <ErrorCustom errors={errors} name="lastName" />
              </div>

              <div className="clientForm__control input-field">
                {activeInput && birthdate ? (
                  <input
                    id="birthdate"
                    name="birthdate"
                    ref={register({ validate: validatorField })}
                    defaultValue={birthdate}
                    readOnly={activeInput}
                    type="text"
                  />
                ) : (
                  <NumberFormat
                    id="birthdate"
                    name="birthdate"
                    format="##/##/####"
                    mask={["d", "d", "m", "m", "a", "a", "a", "a"]}
                    getInputRef={register({
                      validate: (value) => validatorDate(value, setValue),
                    })}
                    autoComplete="off"
                    value={birthdate}
                    type="text"
                  />
                )}
                <label
                  className={birthdate ? "active" : ""}
                  htmlFor="birthdate"
                >
                  Fecha de nacimiento
                </label>
                <ErrorCustom errors={errors} name="birthdate" />
              </div>

              <div className="clientForm__control">
                <label className="clientForm__label" htmlFor="sexo">
                  ¿Cuál es su sexo?
                </label>
                <RadioButtonsSexo
                  register={register({ validate: validatorField })}
                  id="sexo"
                  name="sexo"
                  value={sexo}
                />
                <ErrorCustom errors={errors} name="sexo" />
              </div>

              <div className="clientForm__control input-field">
                <input
                  id="nationality"
                  name="nationality"
                  ref={register({ validate: validatorClientText })}
                  type="text"
                  maxLength="50"
                />
                <label htmlFor="nationality">Nacionalidad</label>
                <ErrorCustom errors={errors} name="nationality" />
              </div>

              <div className="clientForm__control input-field">
                <input
                  id="country"
                  name="country"
                  ref={register({ validate: validatorClientText })}
                  type="text"
                  maxLength="50"
                />
                <label htmlFor="country">País de residencia</label>
                <ErrorCustom errors={errors} name="country" />
              </div>

              <div className="clientForm__control">
                {/* <input
                  id="civilStatus"
                  name="civilStatus"
                  ref={register({ validate: validatorField })}
                  type="text"
                  maxLength="50"
                /> */}
                <label className="clientForm__label" htmlFor="civilStatus">
                  Estado civil
                </label>
                <select
                  id="civilStatus"
                  name="civilStatus"
                  ref={register({ validate: validatorField })}
                >
                  <option value="SOLTERO">Soltero</option>
                  <option value="CASADO">Casado</option>
                  <option value="DIVORCIADO">Divorciado</option>
                  <option value="VIUDO">Viudo</option>
                </select>
                <ErrorCustom errors={errors} name="civilStatus" />
              </div>

              <div className="clientForm__control">
                <label className="clientForm__label" htmlFor="residentUSA">
                  ¿Es ciudadano o residente de EE.UU?
                </label>
                <RadioButtonsResident
                  register={register({ validate: validatorField })}
                  id="residentUSA"
                  name="residentUSA"
                />
                <ErrorCustom errors={errors} name="residentUSA" />
              </div>

              <div className="clientForm__control input-field">
                <input
                  id="profession"
                  name="profession"
                  ref={register({ validate: validatorClientText })}
                  type="text"
                  maxLength="50"
                />
                <label htmlFor="profession">Ingrese su profesión</label>
                <ErrorCustom errors={errors} name="profession" />
              </div>

              <div className="clientForm__control input-field">
                <input
                  id="occupation"
                  name="occupation"
                  ref={register({ validate: validatorClientText })}
                  type="text"
                  maxLength="50"
                />
                <label htmlFor="occupation">Ingrese su ocupación</label>
                <ErrorCustom errors={errors} name="occupation" />
              </div>

              <label className="clientForm__label">Datos de contacto</label>

              <div className="clientForm__control input-field">
                <input
                  id="phone"
                  name="phone"
                  ref={register({ validate: validateHomePhone })}
                  type="text"
                  maxLength="15"
                />
                <label htmlFor="phone">Teléfono de casa</label>
                <ErrorCustom errors={errors} name="phone" />
              </div>

              <div className="clientForm__control input-field">
                <input
                  id="mobile"
                  name="mobile"
                  ref={register({ validate: validatePhone })}
                  defaultValue={mobile}
                  type="text"
                  maxLength="15"
                />
                <label htmlFor="mobile" className={mobile ? "active" : "false"}>
                  Celular
                </label>
                <ErrorCustom errors={errors} name="mobile" />
              </div>

              <div className="clientForm__control input-field">
                <input
                  id="email"
                  name="email"
                  ref={register({ validate: validateEmail })}
                  defaultValue={email}
                  type="text"
                  maxLength="38"
                />
                <label htmlFor="email" className={email ? "active" : "false"}>
                  Correo electrónico
                </label>
                <ErrorCustom errors={errors} name="email" />
              </div>

              <div>
                <label className="clientForm__label_bg">
                  Ingrese su dirección
                </label>
                <ListAddresses
                  address={address}
                  setAddress={setAddress}
                  setOpen={setOpen}
                />
                <p className="errorCustom">{errAddress}</p>
              </div>

              <button
                type="submit"
                className="clientForm__button buttonCustom md"
              >
                Continuar
              </button>
            </form>

            <ModalAddress
              setAddress={setAddress}
              open={open}
              setOpen={setOpen}
            />
          </div>
        </div>
        <div className="column-image">
          <img src={img} />
        </div>
      </div>
    </div>
  );
}
